<div class="page-wrapper" style="min-height: 347px">
  <div class="content container-fluid">
    <div class="bg-white page-border">
      <!--page body contant -->

      <div class="row row-replace">
        <div class="col-md-6 text-center mb-2">
          <div>
            <img
              src="assets/img/exitEmp.jpg"
              style="height: 89%; width: 88%; padding-top: 40px"
            />
          </div>
        </div>

        <div class="col-md-6 bg-main p-3">
          <div
            style="
              font-weight: bold;
              font-size: 21px;
              color: red;
              text-align: center;
              margin-bottom: 10px;
            "
          >
            Employee e-Resignation
          </div>
          <hr />

          <form
            [formGroup]="resignationForm"
            (ngSubmit)="onSubmitResignation()"
          >
            <div class="form-group" style="margin-top: 20px">
              <div class="row" *ngIf="onBehalfUser || isRhr">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa"
                    >On behalf of<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <select
                    class="form-control"
                    formControlName="on_behalf_1"
                    (change)="changIsOnBefalf($event)"
                  >
                    <option value="">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                  <div
                    *ngIf="submitted && exitErrorMsg.on_behalf_1.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.on_behalf_1.errors.required">
                      On behalf is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="on_behalf_1 == 1">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label>Select Employee</label>
                </div>
                <div class="col-md-8 col-sm-8">
                  <select2
                    value="value"
                    [data]="empList"
                    formControlName="on_behalf"
                    (update)="onChangeEmp($event)"
                  >
                  </select2>
                </div>
              </div>
              <div class="row m-t-5" *ngIf="isRhr">
                <div class="col-md-4 col-sm-4"></div>
                <div class="col-md-8 col-sm-8">
                  <div class="row">
                    <div class="col-10 padding-right-2">
                      <div class="form-group">
                        <input
                          type="text"
                          placeholder="Search User"
                          class="form-control"
                          formControlName="emp"
                        />
                      </div>
                    </div>
                    <div class="col-2 col-pn">
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        (click)="srchEmp()"
                        [disabled]="onBehalf"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->
            <div class="form-group" *ngIf="reportiesCount != 0">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label>Replacement RM </label>
                </div>
                <div class="col-md-8 col-sm-8">
                  <div class="row">
                    <div class="col-10 padding-right-2">
                      <div class="form-group">
                        <input
                          type="text"
                          placeholder="Search User"
                          class="form-control"
                          formControlName="rpls_rm_username"
                        />
                      </div>
                    </div>
                    <div class="col-2 col-pn">
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        (click)="srchEmpRpls()"
                        [disabled]="onBehalf"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->

            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa"
                    >Employee ID<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="aaaa"
                    readonly
                    type="text"
                    class="form-control"
                    formControlName="empId"
                  />
                  <input
                    id="aaaa"
                    readonly
                    type="hidden"
                    class="form-control"
                    formControlName="id"
                  />
                  <div
                    *ngIf="submitted && exitErrorMsg.empId.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.empId.errors.required">
                      Employee ID is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="uraal"
                    >Employee Name<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="uraal"
                    type="text"
                    class="form-control"
                    readonly
                    formControlName="emp_name"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa1"
                    >Mobile Number<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="aaaa1"
                    type="number"
                    readonly
                    class="form-control"
                    formControlName="mobile"
                  />
                  <input
                    id="aaaa155"
                    type="hidden"
                    readonly
                    class="form-control"
                    formControlName="user_cate"
                  />
                  <input
                    id="aaaa166"
                    type="hidden"
                    readonly
                    class="form-control"
                    formControlName="hiring_type"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa"
                    >Resignation Type<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <select2
                    value="value"
                    [data]="voltryList"
                    formControlName="vltry_id"
                    (update)="onChangeVltry($event)"
                  >
                  </select2>
                  <div
                    *ngIf="submitted && exitErrorMsg.vltry_id.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.vltry_id.errors.required">
                      Resignation Type is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa"
                    >Reason for Leaving<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <select2
                    value="value"
                    [data]="reasonList"
                    formControlName="rsn_id"
                    (update)="onChangeReason($event)"
                  >
                  </select2>
                  <div
                    *ngIf="submitted && exitErrorMsg.rsn_id.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.rsn_id.errors.required">
                      Reason for Leaving is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="uraal1"
                    >{{ headerDate }}<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="uraal1"
                    type="date"
                    placeholder="dd-mm-yyyy"
                    [min]="CurDat"
                    [max]="today"
                    class="form-control"
                    (change)="chkNotice($event)"
                    formControlName="resignDate"
                  />
                  <div
                    *ngIf="submitted && exitErrorMsg.resignDate.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.resignDate.errors.required">
                      {{ headerDate }} is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="uraal11">Notice Period</label>
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="uraal11"
                    type="text"
                    readonly
                    class="form-control"
                    formControlName="notice_period"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row" *ngIf="showDateFeild">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa1"
                    >Last Working Date<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="aaaa1"
                    type="date"
                    placeholder="dd-mm-yyyy"
                    [min]="resignDate"
                    class="form-control"
                    formControlName="lastDate"
                  />
                  <div
                    *ngIf="submitted && exitErrorMsg.lastDate.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.lastDate.errors.required">
                      Last Working Date is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row" *ngIf="on_behalf_1 == 1">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa"
                    >Potential Win Back<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <select2
                    value="value"
                    [data]="potentialData"
                    formControlName="win_back"
                  >
                  </select2>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row" *ngIf="on_behalf_1 == 1">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa"
                    >Is Blacklisted<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <select2
                    value="value"
                    [data]="blacklistData"
                    formControlName="is_blacklist"
                  >
                  </select2>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="aaaa11"
                    >Comments<span class="text-danger">*</span></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <textarea
                    name="comments"
                    id="aaaa11"
                    cols="20"
                    rows="3"
                    class="form-control"
                    formControlName="comments"
                  ></textarea>
                  <div
                    *ngIf="submitted && exitErrorMsg.comments.errors"
                    class="form-error"
                  >
                    <div *ngIf="exitErrorMsg.comments.errors.required">
                      Remark is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-4 col-sm-4">
                  <label for="uraal11"
                    >Hard copy Resignation Upload<span class="text-danger"
                      ></span
                    ></label
                  >
                </div>
                <div class="col-md-8 col-sm-8">
                  <input
                    id="uraal11"
                    type="file"
                    class="form-control"
                    formControlName="doc"
                    (change)="onFileChange($event)"
                  />
                  <span class="text-danger"
                    >( Please upload only 'pdf', 'jpeg', 'jpg', 'png', 'gif',
                    'doc', 'docx'. Maximum file uploaded size is 10 MB )</span
                  >
                  <br />
                  <div
                    *ngIf="submitted && exitErrorMsg.doc.errors"
                    class="form-error"
                  >
                    <div
                      *ngIf="exitErrorMsg.doc.errors.required"
                      class="btn btn-danger"
                    >
                      Document is required !
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn-primary btn-sm"
              [disabled]="Diss"
            >
              <i class="fa fa-save"></i> Submit
            </button>
          </form>
        </div>
      </div>
      <!--
      <div
        *ngIf="
          (on_behalf_1 == 1 || exitStatus == true) && clearanceList !== null
        "
      >
        <div class="row" style="margin-top: 10px; margin-bottom: 10px">
          <div class="col-md-11">
            <div
              style="
                font-weight: bold;
                font-size: 21px;
                color: red;
                text-align: left;
                margin-bottom: 10px;
                margin-top: 10px;
              "
            >
              Employee Self Clearance Checklist
            </div>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-11">
            <div class="table-responsive">
              <table class="table custom-table mb-0">
                <thead>
                  <tr>
                    <th>S NO.</th>
                    <th>Department</th>
                    <th>Checklist</th>
                    <th>Status</th>

                    <th>Upload File</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dat of clearanceList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ dat.dept_desc }}</td>
                    <td>{{ dat.chklst_desc }}</td>
                    <td>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          [(ngModel)]="dat.status"
                          [ngModelOptions]="{ standalone: true }"
                          name="bank_{{ i }}"
                          type="radio"
                          value="1"
                        />
                        <label class="form-check-label" for="">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          [(ngModel)]="dat.status"
                          [ngModelOptions]="{ standalone: true }"
                          name="bank_{{ i }}"
                          type="radio"
                          value="0"
                        />
                        <label class="form-check-label" for="">No</label>
                      </div>
                    </td>

                    <td>
                      <div class="row">
                        <div class="col-md-10">
                          <input
                            class="form-control"
                            type="file"
                            [(ngModel)]="dat.doc_attachment"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="onFileChange($event, i)"
                          />
                        </div>
                        <div class="col-md-2">
                          <a
                            *ngIf="dat.attachment != ''"
                            href="{{ dat.attachment }}"
                            class="mt-5"
                            download=""
                            target="_blank"
                            ><i class="fa fa-paperclip"></i
                          ></a>
                        </div>
                      </div>
                    </td>
                    <td *ngIf="dat.edit_id == ''">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        (click)="saveExitEmployee(i)"
                      >
                        <i class="fa fa-check" aria-hidden="true"></i> Save
                      </button>
                    </td>
                    <td *ngIf="dat.edit_id != ''">
                      <button
                        type="button"
                        class="btn btn-sm btn-success"
                        (click)="saveExitEmployee(i)"
                      >
                        <i class="fa fa-check" aria-hidden="true"></i> Update
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-sm btn-danger"
              (click)="finishExitEmpClearance()"
            >
              <i class="fa fa-check" aria-hidden="true"></i> Finish
            </button>
          </div>
        </div>
      </div> -->

      <!--end page body contant -->
    </div>
  </div>
</div>
<!-- /Page Wrapper -->

<!-- Apply Employee Leave modal -->
<div
  id="exit_modal"
  class="modal custom-modal fade"
  role="dialog"
  style="display: none"
  data-select2-id="add_leave"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Employee Self Clearance Checklist</h5>
        <!-- (click)="onCloseModal()" -->
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- BEGIN MODAL BODY -->
        <div class="row">
          <div class="col-md-11">
            <div class="table-responsive">
              <table class="table custom-table mb-0">
                <thead>
                  <tr>
                    <th>S NO.</th>
                    <th>Department</th>
                    <th>Checklist</th>
                    <th>Status</th>
                    <!-- <th>Value/Amount</th>
                                    <th>Remark</th> -->
                    <th>Upload File</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dat of clearanceList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ dat.dept_desc }}</td>
                    <td>{{ dat.chklst_desc }}</td>
                    <td>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          [(ngModel)]="dat.status"
                          [ngModelOptions]="{ standalone: true }"
                          name="bank_{{ i }}"
                          type="radio"
                          value="1"
                        />
                        <label class="form-check-label" for="">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          [(ngModel)]="dat.status"
                          [ngModelOptions]="{ standalone: true }"
                          name="bank_{{ i }}"
                          type="radio"
                          value="0"
                        />
                        <label class="form-check-label" for="">No</label>
                      </div>
                    </td>
                    <!-- <td><input class="form-control" type="number" name="number" [(ngModel)]="dat.number" [ngModelOptions]="{standalone: true}" /></td>
                                    <td><input class="form-control" type="text" name="number" [(ngModel)]="dat.remark" [ngModelOptions]="{standalone: true}" /></td> -->
                    <td>
                      <div class="row">
                        <div class="col-md-10">
                          <input
                            class="form-control"
                            type="file"
                            [(ngModel)]="dat.doc_attachment"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="onFileChange($event, i)"
                          />
                        </div>
                        <div class="col-md-2">
                          <a
                            *ngIf="dat.attachment != ''"
                            href="{{ dat.attachment }}"
                            class="mt-5"
                            download=""
                            target="_blank"
                            ><i class="fa fa-paperclip"></i
                          ></a>
                        </div>
                      </div>
                    </td>
                    <td *ngIf="dat.edit_id == ''">
                      <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        (click)="saveExitEmployee(i)"
                      >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Save
                      </button>
                    </td>
                    <td *ngIf="dat.edit_id != ''">
                      <button
                        type="button"
                        class="btn btn-sm btn-success"
                        (click)="saveExitEmployee(i)"
                      >
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Update
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center mt-4">
            <button
              type="button"
              class="btn btn-sm btn-danger"
              (click)="finishExitEmpClearance()"
            >
              <i class="fa fa-check" aria-hidden="true"></i> Finish
            </button>
          </div>
        </div>
        <!-- END OF MODAL BODY -->
      </div>
    </div>
  </div>
</div>
